import React, { forwardRef } from 'react'
import styled from 'styled-components'

const PageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 0.707; /* A4 ratio (210mm x 297mm) */
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  page-break-after: always;
  position: relative;
`

interface PDFPagePreviewProps {
  children: React.ReactNode
}

export const PDFPagePreview = forwardRef<HTMLDivElement, PDFPagePreviewProps>(
  ({ children }, ref) => {
    return <PageWrapper ref={ref}>{children}</PageWrapper>
  }
)

PDFPagePreview.displayName = 'PDFPagePreview'
